export class EventDispatcher {

    constructor() {

        this._handlers = new Set();

    }

    subscribe(handler) {
        this._handlers.add(handler);
        return () => this._handlers.delete(handler);
    }

    subscribeHandler() {
        return (handler) => this.subscribe(handler);
    }

    unsubscribe(handler) {
        this._handlers.delete(handler);
    }

    dispatch(e) {
        for (const h of this._handlers) {
            try { h(e); } catch { /* swallow */ }
        }
    }

}